export default __webpack_public_path__ + "5f9e94a97797f6b2555b217d599f137f.svg";